module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"policy":"Privacy Policy","recaptcha":"This site is protected by reCAPTCHA and the Google {policy} and {terms} apply.","terms":"Terms of Service"}}')
  delete Component.options._Ctor
}
